<quill-editor
    *ngIf="!editHTML"
    id="agpr_quillTextEditor_element"
    class="agpr-richTextEditor"
    [bounds]="'self'"
    [placeholder]="''"
    [modules]="config"
    [styles]="quillEditorContentStyles"
    [ngModel]="isTranslating ? translation.translatedContent : value"
    (ngModelChange)="change()"
    (onEditorCreated)="editorCreated($event)"
    (onEditorChanged)="editorChange($event)"
    (onSelectionChanged)="selectionChange($event)"
    [ngClass]="{
        'agpr-centerAlign': centerAlign,
        'agpr-rightAlign': rightAlign
    }"
>
    <div
        id="agpr_quillTextEditor_toolbar"
        quill-editor-toolbar
    >
        <div class="agpr-richTextEditor-toolbarItems">
            <span
                *ngIf="enableFontFamily || enableFontSize || enableLineHeight || enableHeading"
                class="ql-formats"
            >
                <span class="input-wrapper">
                    <select
                        *ngIf="enableFontFamily"
                        id="quill_fontFamily_dropdown"
                        class="ql-font"
                        [pTooltip]="'Common.forms.richText.fontFamily' | localize"
                        tooltipPosition="top"
                        [attr.aria-label]="'Common.forms.richText.fontFamily' | localize"
                    >
                        <option value="Arial, Helvetica, sans-serif">{{ 'Font.arial' | localize }}</option>
                        <option value="Comic Sans MS, Helvetica, sans-serif">{{ 'Font.comicSans' | localize }}</option>
                        <option value="Courier New, Courier, monospace"> {{ 'Font.courierNew' | localize }}</option>
                        <option value="Georgia, serif">{{ 'Font.georgia' | localize }}</option>
                        <option value="Helvetica, Arial, sans-serif">{{ 'Font.helvetica' | localize }}</option>
                        <option value="Lucida Sans Unicode, Lucida Grande, sans-serif">{{ 'Font.lucida' | localize }}</option>
                        <option value="Tahoma, Geneva, sans-serif">{{ 'Font.tahoma' | localize }}</option>
                        <option value="Times New Roman, Times, serif">{{ 'Font.times' | localize }}</option>
                        <option value="Trebuchet MS, Helvetica, sans-serif">{{ 'Font.trebuchet' | localize }}</option>
                        <option value="Verdana, Geneva, sans-serif">{{ 'Font.verdana' | localize }}</option>
                    </select>
                </span>
                <span class="input-wrapper">
                    <select
                        *ngIf="enableFontSize"
                        id="quill_fontSize_dropdown"
                        class="ql-size"
                        [pTooltip]="'Common.forms.richText.fontSize' | localize"
                        tooltipPosition="top"
                        [attr.aria-label]="'Common.forms.richText.fontSize' | localize"
                    >
                        <option value="8px">8px</option>
                        <option value="9px">9px</option>
                        <option value="10px">10px</option>
                        <option value="12px">12px</option>
                        <option value="14px">14px</option>
                        <option value="16px">16px</option>
                        <option value="18px">18px</option>
                        <option value="20px">20px</option>
                        <option value="22px">22px</option>
                        <option value="24px">24px</option>
                        <option value="26px">26px</option>
                        <option value="28px">28px</option>
                        <option value="36px">36px</option>
                        <option value="48px">48px</option>
                        <option value="72px">72px</option>
                    </select>
                </span>

                <span class="input-wrapper">
                    <select
                        *ngIf="enableLineHeight"
                        id="quill_lineHeight_dropdown"
                        class="ql-lineheight"
                        [pTooltip]="'Common.forms.richText.lineSpacing' | localize"
                        tooltipPosition="top"
                        [attr.aria-label]="'Common.forms.richText.lineSpacing' | localize"
                    >
                        <ng-container *ngFor="let option of lineSpacingOptions; index as i;">
                            <option [value]="option.value" [label]="option.label"></option>
                        </ng-container>
                    </select>
                </span>

                <span class="input-wrapper">
                    <select
                        *ngIf="enableHeading"
                        id="quill_header_dropdown"
                        class="ql-header"
                        [pTooltip]="'Common.forms.richText.header' | localize"
                        tooltipPosition="top"
                        [attr.aria-label]="'Common.forms.richText.header' | localize"
                    ></select>
                </span>

            </span>

            <span class="ql-formats">
                <button
                    id="quill_bold_button"
                    class="ql-bold ql-button"
                    agprTooltip="Common.forms.richText.bold"
                    tooltipPosition="top"
                    [attr.aria-pressed]="isBold"
                ></button>
                <button
                    id="quill_italics_button"
                    class="ql-italic ql-button"
                    agprTooltip="Common.forms.richText.italic"
                    tooltipPosition="top"
                    [attr.aria-pressed]="isItalic"
                ></button>
                <button
                    id="quill_underline_button"
                    class="ql-underline ql-button"
                    agprTooltip="Common.forms.richText.underline"
                    tooltipPosition="top"
                    [attr.aria-pressed]="isUnderlined"
                ></button>
                <button
                    *ngIf="enableStrikethrough"
                    id="quill_strikethrough_button"
                    class="ql-strike ql-button ql-button--custom"
                    agprTooltip="Common.forms.richText.strikeThrough"
                    tooltipPosition="top"
                    [attr.aria-pressed]="isStrikethrough"
                >
                    <span class="fa-regular fa-duotone fa-strikethrough" role="img"></span>
                </button>
            </span>
            <span
                class="ql-formats"
                *ngIf="enableFontColor || enableBackgroundColor"
            >
                <agpr-color-picker-trigger
                    *ngIf="enableFontColor"
                    [id]="'quill_customFontColor_button'"
                    class="agpr-color-picker-button-container"
                    icon="agpr-i-font-color"
                    tooltip="Common.forms.richText.fontColor"
                    tooltipPosition="top"
                    [value]="selectedColor"
                    (valueChange)="setColorProperty('color')"
                >
                </agpr-color-picker-trigger>

                <agpr-color-picker-trigger
                    *ngIf="enableBackgroundColor"
                    [id]="'quill_customBackgroundColor_button'"
                    class="agpr-color-picker-button-container"
                    icon="fa-regular fa-highlighter"
                    tooltip="Common.forms.richText.highlightText"
                    tooltipPosition="top"
                    [value]="selectedFontBackgroundColor"
                    (valueChange)="setColorProperty('background')"
                >
                </agpr-color-picker-trigger>
            </span>

            <span
                role="radiogroup"
                class="ql-formats"
            >
                <button
                    role="radio"
                    id="quill_subscript_button"
                    class="ql-script ql-button ql-button--custom"
                    value="sub"
                    agprTooltip="Common.forms.richText.subscript"
                    tooltipPosition="top"
                    [attr.aria-checked]="selectedScript === 'sub'"
                >
                    <span class="fa-regular fa-subscript" role="img"></span>
                </button>
                <button
                    role="radio"
                    id="quill_superscript_button"
                    class="ql-script ql-button ql-button--custom"
                    value="super"
                    agprTooltip="Common.forms.richText.superscript"
                    tooltipPosition="top"
                    [attr.aria-checked]="selectedScript === 'super'"
                >
                    <span class="fa-regular fa-superscript" role="img"></span>
                </button>
            </span>

            <span
                role="radiogroup"
                class="ql-formats"
            >
                <button
                    *ngIf="enableNumberedList"
                    role="radio"
                    id="quill_orderedList_button"
                    class="ql-list ql-button ql-button--custom"
                    value="ordered"
                    agprTooltip="Common.forms.richText.numberedList"
                    tooltipPosition="top"
                    [attr.aria-checked]="selectedListType === 'ordered'"
                >
                    <span class="fa-regular fa-list-ol" role="img"></span>
                </button>
                <button
                    role="radio"
                    id="quill_bulletList_button"
                    class="ql-list ql-button ql-button--custom"
                    value="bullet"
                    agprTooltip="Common.forms.richText.bulletList"
                    tooltipPosition="top"
                    [attr.aria-checked]="selectedListType === 'bullet'"
                >
                    <span class="fa-regular fa-list-ul" role="img"></span>
                </button>
            </span>

            <span
                *ngIf="enableAlignment"
                role="radiogroup"
                class="ql-formats"
                [attr.aria-label]="'Common.forms.richText.alignment' | localize"
            >
                <button
                    role="radio"
                    id="quill_customLeftAlign_button"
                    class="ql-button ql-button--custom"
                    [ngClass]="{ 'ql-active' : selectedAlignment === 'left' }"
                    agprTooltip="Common.forms.richText.leftAlign"
                    tooltipPosition="top"
                    [attr.aria-checked]="selectedAlignment === 'left'"
                    (click)="setAlignment('left')"
                >
                    <span class="fa-solid fa-align-left" role="img"></span>
                </button>

                <button
                    role="radio"
                    id="quill_customCenterAlign_button"
                    class="ql-button ql-button--custom"
                    [ngClass]="{ 'ql-active' : selectedAlignment === 'center' }"
                    agprTooltip="Common.forms.richText.centerAlign"
                    tooltipPosition="top"
                    [attr.aria-checked]="selectedAlignment === 'center'"
                    (click)="setAlignment('center')"
                >
                    <span class="fa-regular fa-align-center" role="img"></span>
                </button>

                <button
                    role="radio"
                    id="quill_customRightAlign_button"
                    class="ql-button ql-button--custom"
                    [ngClass]="{ 'ql-active' : selectedAlignment === 'right' }"
                    agprTooltip="Common.forms.richText.rightAlign"
                    tooltipPosition="top"
                    [attr.aria-checked]="selectedAlignment === 'right'"
                    (click)="setAlignment('right')"
                >
                    <span class="fa-regular fa-align-right" role="img"></span>
                </button>

                <button
                    role="radio"
                    id="quill_customJustifyAlign_button"
                    class="ql-button ql-button--custom"
                    [ngClass]="{ 'ql-active' : selectedAlignment === 'justify' }"
                    agprTooltip="Common.forms.richText.justifyAlign"
                    tooltipPosition="top"
                    [attr.aria-checked]="selectedAlignment === 'justify'"
                    (click)="setAlignment('justify')"
                >
                    <span class="fa-regular fa-duotone fa-align-justify" role="img"></span>
                </button>
            </span>

            <span
                *ngIf="enableIndent"
                class="ql-formats"
            >
                <button
                    id="quill_decreaseIndent_button"
                    class="ql-indent ql-button ql-button--custom"
                    value="-1"
                    agprTooltip="Common.forms.richText.decreaseIndent"
                    tooltipPosition="top"
                >
                    <span class="fa-regular fa-duotone fa-outdent" role="img"></span>
                </button>
                <button
                    id="quill_increaseIndent_button"
                    class="ql-indent ql-button ql-button--custom"
                    value="+1"
                    agprTooltip="Common.forms.richText.increaseIndent"
                    tooltipPosition="top"
                >
                    <span class="fa-regular fa-indent" role="img"></span>
                </button>
            </span>

            <span
                *ngIf="enableDirection"
                class="ql-formats"
            >
                <button
                    id="quill_direction_button"
                    class="ql-direction ql-button ql-button--custom"
                    value="rtl"
                    agprTooltip="Common.forms.richText.direction"
                    tooltipPosition="top"
                    [attr.aria-label]="'Common.forms.richText.directionAriaLabel' | localize"
                    [attr.aria-pressed]="isRTL"
                >
                    <span class="fa-solid fa-paragraph" role="img"></span>
                </button>
            </span>

            <span
                class="ql-formats"
                *ngIf="enableBlockQuote"
            >
                <button
                    id="quill_blockQuote_button"
                    class="ql-blockquote ql-button ql-button--custom"
                    agprTooltip="Common.forms.richText.blockquote"
                    tooltipPosition="top"
                    [attr.aria-pressed]="isBlockQuote"
                >
                    <span class="fql-buttona-solid fa-quote-right" role="img"></span>
                </button>
            </span>

            <span class="ql-formats">
                <button
                    id="quill_link_button"
                    class="ql-button ql-button--custom"
                    agprTooltip="Common.forms.richText.link"
                    tooltipPosition="top"
                    (click)="setLink()"
                >
                    <span class="fa-regular fa-link" role="img"></span>
                </button>
            </span>

            <!--
                @TODO - AD-11342 - uncomment once image problem solved.
                <span class="ql-formats">
                <button
                    class="ql-image ql-button"
                    data-toggle="tooltip"
                    data-placement="top"
                    [title]="'Common.forms.richText.image' | localize"
                >
                </button>
            </span> -->

            <span
                *ngIf="enableInsertImage"
                class="ql-formats"
            >
                <div class="agpr-richTextEditor-customImage">
                    <button
                        id="quill_image_button"
                        class="ql-button ql-button--custom agpr-richTextEditor-customImage"
                        agprTooltip="Common.forms.richText.image"
                        tooltipPosition="top"
                        (click)="imageInput.click()"
                    >
                        <span class="fa-regular fa-image" role="img"></span>
                    </button>
                    <input
                        #imageInput
                        class="agpr-richTextEditor-customImageInput"
                        type="file"
                        accept="image/gif, image/jpeg, image/png"
                        [attr.aria-label]="'Common.forms.richText.image' | localize"
                        (change)="handleFileInput($event.target.files[0], imageInput)"
                    >
                </div>
            </span>

            <span class="ql-formats">
                <button
                    id="quill_clearStyles_button"
                    class="ql-clean ql-button ql-button--custom"
                    agprTooltip="Common.forms.richText.clearStyles"
                    tooltipPosition="top"
                >
                    <span class="fa-regular fa-text-slash" role="img"></span>
                </button>
            </span>

            <span class="ql-formats">
                <button
                    id="quill_undo_button"
                    class="ql-button ql-button--custom fa-regular fa-arrow-rotate-left"
                    agprTooltip="Common.forms.richText.undo"
                    tooltipPosition="top"
                    (click)="handleHistory('undo')"
                >
                </button>
                <button
                    id="quill_redo_button"
                    class="ql-button ql-button--custom fa-regular fa-arrow-rotate-right"
                    agprTooltip="Common.forms.richText.redo"
                    tooltipPosition="top"
                    (click)="handleHistory('redo')"
                >
                </button>
            </span>
        </div>

        <div
            *ngIf="enablePersonalizations || enableHtmlEditor || ((enableAIHelper || (enableAIRefinement || enableTranslation)) && openAiPermission)"
            class="agpr-richTextEditor-action-buttons"
        >
            <div
                class="agpr-richTextEditor-language"
                *ngIf="enableTranslation"
            >
                <agpr-autocomplete
                    [id]="'quill_redo_language'"
                    class="agpr-richTextEditor-language-autocomplete"
                    labelField="label"
                    ariaLabel="Mention.translateDropdown"
                    [dropdown]="true"
                    [(ngModel)]="selectedLanguage"
                    [suggestions]="languageSuggestions$"
                    [multiSelection]="false"
                    [clearOnBlur]="false"
                    (searchStringChanged)="updateListAfterString($event)"
                ></agpr-autocomplete>
                <agpr-button
                    [style]="buttonTypes.link"
                    [id]="'quill_redo_language_translate_button'"
                    (click)="translate()"
                    [icon]="'fa-kit-duotone fa-agpr-translate'"
                    [disabled]="isTranslating || !value"
                    [tooltip]="isTranslating ? 'Mention.translating' :
                        ('Mention.translateTo' | localize: {
                            language: selectedLanguage?.label
                        })
                    "
                    tooltipPosition="top"
                ></agpr-button>
            </div>
            <div>
                <span
                    *ngIf="enableHtmlEditor"
                    id="quill_htmlEditor_buttonWrapper"
                    class="ql-formats"
                >
                    <button
                        id="quill_htmlEditor_button"
                        class="ql-button"
                        agprTooltip="Common.forms.richText.editHtml"
                        (click)="showSwitchEditingModeWarning()"
                    >
                        {{ 'Common.forms.richText.htmlEditor' | localize }}
                    </button>
                </span>

                <span class="ql-formats">
                    <agpr-icon-dropdown
                        *ngIf="enablePersonalizations"
                        id="quill_mergeTags_dropdown"
                        class="ql-mergetags"
                        displayIcon="fa-regular fa-duotone fa-user-tag"
                        [options]="mergeTagOptions"
                        [customOptions]="mergeTagCustomOptions"
                        [keepSelectedValue]="false"
                        agprTooltip="Common.forms.richText.mergeTags"
                        ariaLabel="Common.forms.richText.mergeTags"
                        (change)="setMergeTag($event.value)"
                    ></agpr-icon-dropdown>
                    <a
                        *ngIf="enablePersonalizations"
                        [href]="isFooter ? footerMergeTagsInfoArticle : mergeTagsInfoArticle"
                        target="_blank"
                        id="quill_mergeTags_link"
                        class="fa-regular fa-circle-info agpr-infoCircle"
                        [agprTooltip]="isFooter ? footerMergeTagsInfoTemplate : mergeTagsInfoTemplate"
                        tooltipPosition="right"
                        [hideDelay]="1500"
                        [escape]="false"
                    ></a>
                </span>
            </div>

            <span
                *ngIf="(enableAIHelper || enableAIRefinement) && openAiPermission"
                id="quill_enableAIHelper_buttonWrapper"
                class="ql-formats"
            >
                <button
                    *ngIf="this.isEmpty && enableAIHelper"
                    id="quill_enableAIHelper_button"
                    class="ql-button"
                    [pTooltip]="'Common.forms.richText.aiHelper' | localize"
                    tooltipPosition="top"
                    (click)="launchAIHelperDialog()"
                >
                    <span
                        aria-hidden="true"
                        class="fa-regular fa-brain-circuit"
                    ></span>
                    {{ 'Common.forms.richText.aiHelper' | localize }}
                </button>

                <button
                    *ngIf="enableAIRefinement || (!this.isEmpty && enableAIHelper)"
                    id="quill_enableAIRefinement_button"
                    class="ql-button"
                    [ngClass]="{'ql-button--disabled' : isTranslating || !value}"
                    [disabled]="isTranslating || !value"
                    [agprTooltip]="'Common.forms.richText.aiRefinement' | localize"
                    tooltipPosition="top"
                    (click)="launchAIRefinementDialog()"
                >
                    <span
                        aria-hidden="true"
                        class="fa-kit-duotone fa-agpr-ai"
                    ></span>
                </button>
            </span>
        </div>
    </div>

    <div
        #editorElement
        quill-editor-element
    ></div>
</quill-editor>

<div class="agpr-richTextEditor-html" *ngIf="editHTML">
    <!-- <div class="agpr-richTextEditor-htmlToolbar">
        <agpr-button [style]="buttonTypesEnum.outline" (click)="showSwitchEditingModeWarning()">Text Editor</agpr-button>
    </div> -->
    <agpr-accessible-code-mirror
        [value]="value"
        [config]="codeMirrorConfig"
        (htmlChange)="htmlChange($event)"
    >
    </agpr-accessible-code-mirror>
</div>
